import React from 'react';
import PropTypes from 'prop-types';
import css from './HistoryHeader.css';
import moment from 'moment';

function HistoryHeader(props) {
  return (
    <div className={css['header']}>
      <h1 data-role="headerTitle">Student check-ins for {props.formatDate(moment().toDate(), 'weekdayDateDisplayFormat')}</h1>
      <h2 data-role="headerSubtitle">
        The following students have checked in via the Kiosk today. 
        Click the edit button to add/update the description for their visit.
      </h2>
    </div>
  );
}

HistoryHeader.propTypes = {
  formatDate: PropTypes.func.isRequired,
};

export default HistoryHeader;
